import {observable, action, computed} from 'mobx';

class HierarchyItem {
  constructor(content) {
    this.content = content;
  }

  @computed get locationId() {
    return this.content.BusinessUnit_Id;
  }

  @computed get locationName() {
    return this.content.BusinessUnit_Name;
  }

  @computed get categoryId() {
    return this.content.RentalCategory_Id;
  }

  @computed get categoryName() {
    return this.content.Name;
  }

  @computed get subcategoryId() {
    return this.content.RentalSubcategory_Id;
  }

  @computed get subcategoryName() {
    return this.content.RentalSubcategory_Name;
  }

  @computed get lat() {
    return this.content.BusinessUnit_Latitude;
  }

  @computed get lon() {
    return this.content.BusinessUnit_Longitude;
  }
}

export class Hierarchy {
  @observable content = [];
  oldOrganizationId;

  constructor(api) {
    this.api = api;
  }

  @computed get isLoaded() {
    return this.content.length > 0; 
  } 

  @action async fetch({orgId}) {
    if(this._loadingPromise) {
      return this._loadingPromise;
    }
    try {
      if(this.oldOrganizationId !== orgId) {
        this._loadingPromise = this.api.getSectionsWithRentalObjects({
          organizationId: orgId,
        });
        this.content = await this._loadingPromise;
        this.oldOrganizationId = orgId; 
      }
    }
    finally {
      this._loadingPromise = undefined;
    }
  }

  @computed get items() {
    return this.content.map(o => new HierarchyItem(o));
  }
}


// WEBPACK FOOTER //
// ./src/model/Hierarchy.js